// extracted by mini-css-extract-plugin
export var dividerLine = "_55-0";
export var errorBackground = "_55-1";